module.exports = __webpack_public_path__ + "fonts/inter-v20-latin-regular.da03732a.woff2";